module.exports = __webpack_public_path__ + "static/media/redtiger.145bc456.svg";